// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2VNdX","col":"CardReaderDesc_col__1XgwA","label":"CardReaderDesc_label__38V4K"};